// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-461fc4ca]:after{content:\" *\";color:red}.p-card[data-v-461fc4ca]{box-shadow:none}.p-dialog .p-card .p-card-body[data-v-461fc4ca]{padding:0!important}.break-line[data-v-461fc4ca]{white-space:break-spaces}", ""]);
// Exports
module.exports = exports;
